<!-- ----------------------------------------------- -->
<template>
  <nav id="pcHeader" class="primary">
    <v-navigation-drawer
      v-model="drawer"
      :clipped="false"
      app
      temporary
      right
      width="320"
    >
      <v-list-item @click="openInfoList">
        <v-list-item-icon>
          <v-icon>announcement</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>お知らせ</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="openGlossary">
        <v-list-item-icon>
          <v-icon>import_contacts</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>防災用語ウェブサイト</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="openLinkList">
        <v-list-item-icon>
          <v-icon>insert_link</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>リンク集</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="openScreenManual">
        <v-list-item-icon>
          <v-icon>mdi-monitor-screenshot</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>画面解説書</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="openSiteMap">
        <v-list-item-icon>
          <v-icon>web</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>サイトマップ（トップページ）</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="openInquiry" v-if="!getModeTest">
        <v-list-item-icon>
          <v-icon>email</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>お問い合わせ</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item @click="openCaution">
        <v-list-item-icon>
          <v-icon>playlist_add_check</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>ご利用上の注意事項</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <div class="frics-box ma-4">
        <v-spacer></v-spacer>
        <div class="menu-frics text-right mb-2">
          <span class="font-weight-bold grey--text text--darken-1"
            >Compiled by FRICS</span
          >
        </div>
      </div>
    </v-navigation-drawer>
    <v-row class="pc-app-bar-frame mx-0">
      <img
        class="title-pic"
        :src="getTitleImg"
        style="cursor: pointer;"
        @click="openPortal"
        v-if="!getModeTest"
      />
      <v-spacer></v-spacer>
      <span v-if="!notShowBtn">
        <!-- <v-btn
          v-show="$route.path.includes('/pc/')"
          text
          small
          color="success"
          class="mt-2"
          @click="dispRegistPoint"
        >
          <v-icon left color="white">home</v-icon>
          <span class="pc-header-link white--text">地点登録</span>
        </v-btn> -->
        <v-btn
          v-show="$route.path.includes('/pc/')"
          text
          small
          color="success"
          class="mt-2"
          @click="openSrchDlg"
        >
          <v-icon left color="white">search</v-icon>
          <span class="pc-header-link white--text">観測所検索</span>
        </v-btn>
        <v-btn text small color="success" class="mt-2 mr-2" @click="openManual">
          <v-icon left color="white">headset_mic</v-icon>
          <span class="pc-header-link white--text">操作説明</span>
        </v-btn>
        <v-btn icon small @click="drawer = !drawer" class="mr-2">
          <v-icon color="white">menu</v-icon>
        </v-btn>
        <app-guide-dlg v-if="showGuide" @close="closeManual"></app-guide-dlg>
        <tm-search v-show="showSrchDlg"></tm-search>
      </span>
    </v-row>
  </nav>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用ヘッダ
 * Header.vue
 * @author LIS
 */
import mixin from "../../lib/mixin.js";
import PageLog from "../../lib/pageLog.js";
import appGuideDlg from "../../components/pc/AppGuideDlg";
import tmSearch from "../full/TmSearch";

export default {
  /** タグ名 */
  name: "kwb-pc-header",
  mixins: [mixin],
  components: {
    appGuideDlg,
    tmSearch,
  },
  data() {
    return {
      drawer: null,
      showGuide: false,
    };
  },
  computed: {
    /** URL */
    urls: {
      get() {
        return this.$store.state.app.config.appConfig.linkUrls;
      },
    },
    /** タイトル画像のPath */
    getTitleImg: {
      get() {
        let titlePath = "/kawabou/img/apptitle_gen.png";
        if (global.KWB_MODE === "admin") {
          titlePath = "/kawabou/img/apptitle_adm.png";
        }
        return titlePath;
      },
    },
    /** テストモード起動 */
    getModeTest: {
      get() {
        return global.TEST_MODE === "test";
      },
    },
    showSrchDlg: {
      get() {
        return this.$store.state.search.showSrchDlg;
      },
    },
    notShowBtn: {
      get() {
        return this.$store.state.sns.showTwitterCheck;
      },
    },
  },
  methods: {
    /** タイトル画像選択 */
    openPortal() {
      window.location = this.urls.portalpc;
    },
    /** お知らせ詳細画面表示 */
    openInfoList() {
      // todo: 緊急お知らせ一覧の検索結果を出力するパラメータを設定する
      let routeData = this.$router.resolve({
        name: "info",
        query: {
          fld: this.$store.state.app.fldCtlParty,
        },
      });
      window.open(routeData.href, "_self");
    },
    /** 用語集 */
    openGlossary() {
      // アクセスログ出力
      PageLog.log({
        page_log: "glossary",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      window.open(this.urls.glossary, "_blank");
    },
    /** リンク集 */
    openLinkList() {
      // アクセスログ出力
      PageLog.log({
        page_log: "book",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      window.open(this.urls.linklist, "_self");
    },
    /** イベント */
    openEvent() {
      // アクセスログ出力
      PageLog.log({
        page_log: "ivent",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      window.open(this.urls.event, "_self");
    },
    /** 画面解説書 */
    openScreenManual() {
      // アクセスログ出力
      PageLog.log({
        page_log: "screendescrip",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      window.open(this.urls.manual, "_self");
    },
    /** サイトマップ */
    openSiteMap() {
      window.open(this.urls.sitemap, "_self");
    },
    /** お問い合わせ */
    openInquiry() {
      window.open(this.urls.inquiry, "_blank");
    },
    /** ご利用上の注意事項 */
    openCaution() {
      // アクセスログ出力
      PageLog.log({
        page_log: "notes",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      window.open(this.urls.caution, "_self");
    },
    /** 観測所検索ダイアログ表示 */
    openSrchDlg() {
      this.$store.commit(
        "search/setShowSrchDlg",
        !this.$store.state.search.showSrchDlg
      );
      // let routeData = this.$router.resolve({
      //   name: "search",
      //   query: {
      //     fld: this.$store.state.app.fldCtlParty
      //   }
      // });
      // window.open(routeData.href, "_blank");
    },
    /** 操作説明 */
    openManual() {
      // アクセスログ出力
      PageLog.log({
        page_log: "manual",
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      this.$log.debug("[app]openManual()");
      this.showGuide = true;
    },
    closeManual() {
      this.$log.debug("[app]closeManual()");
      this.showGuide = false;
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#pcHeader {
  display: block;
  min-width: 500px;
  height: 48px;
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  z-index: 3500;
}
.pc-app-bar-frame {
  align-items: center;
  height: 100%;
  color: #fff;

  img {
    height: 100%;
  }
}
.menu-frics {
  letter-spacing: 0.03em;
  font-size: 0.9em;
}
.frics-box {
  min-height: calc(100% - 480px);
  display: flex;
  align-items: flex-end;
}
</style>
